import React, { Fragment } from "react";
import { connect } from "react-redux";

import clickWrap from "@js/helpers/click_wrap.js";
import { objectForEach } from "@js/helpers/iterators.js";
import {
  ceBackgroundSaveHideErrorBanner,
  ceBackgroundSaveShowErrorBanner,
  ceBackgroundSave,
} from "@js/actions/studio/background_save.js";

import { ceModalEditSubjectOpen } from "@js/actions/studio/campaign_content_section/modal_edit_subject.js";
import { ceModalEditNameOpen } from "@js/actions/studio/campaign_content_section/modal_edit_name.js";

const mapStateToProps = (state) => ({
  attachments: state.data.attachments,
  contents: state.data.contents,
  data_generation_id: state.sync.data_generation_id,
  last_publish_had_validation_errors:
    state.sync.last_publish_had_validation_errors,
  last_published_generation_id: state.sync.last_published_generation_id,
  network_failure_stopped: state.sync.network_failure_stopped,
  publish_in_progress: state.sync.publish_in_progress,
  show_error_banner: state.sync.show_error_banner,
  validation_errors: state.sync.validation_errors,
});

export const ContentBackgroundSaveSection = connect(mapStateToProps)(
  (props) => {
    return props.show_error_banner ? (
      <ContentBackgroundSaveBanner />
    ) : (
      <ContentBackgroundSaveWidget />
    );
  },
);

export const ContentBackgroundSaveWidget = connect(mapStateToProps)((props) => {
  let isBad = false;
  let text = "";

  let textColor = () => (isBad ? "red" : "black");

  if (props.data_generation_id == props.last_published_generation_id) {
    if (!props.last_publish_had_validation_errors) {
      text = t("phrases.react_content.changes_saved");
    } else {
      isBad = true;
      text = (
        <a
          href="#"
          style={{ color: textColor() }}
          onClick={(e) => {
            e.preventDefault();
            props.dispatch(ceBackgroundSaveShowErrorBanner());
          }}
        >
          {t("phrases.react_content.changes_not_saved")}
        </a>
      );
    }
  } else {
    if (props.publish_in_progress) {
      text = t("phrases.react_content.saving_changes");
    } else if (props.network_failure_stopped) {
      isBad = true;
      text = (
        <a
          href="#"
          style={{ color: textColor() }}
          onClick={(e) => {
            e.preventDefault();
            props.dispatch(ceBackgroundSave());
          }}
        >
          {t("phrases.react_content.network_errors_saving")}
        </a>
      );
    } else {
      text = t("phrases.react_content.saving_changes") + "...";
    }
  }

  return (
    <div
      className="pull-right background-save-section"
      style={{ color: textColor() }}
    >
      {text}
    </div>
  );
});

const formatError = (dispatch, objectName, type, key, err) => {
  let i18nContainerKey = `react_background_save_errors.${type}`;
  let i18nFieldKey = `react_background_save_errors.${type}.${key}`;

  // Errors flagged as "base" are those that are on the object but not
  // associated with any particular field. We don't need to tell the user what
  // field to which it relates.
  if (key === "base") {
    return t(`react_background_save_errors.messages.${type}_base`, {
      name: objectName,
      err: err,
    });
  }
  let area;
  try {
    area = key in t(i18nContainerKey) ? t(i18nFieldKey) : key;
  } catch (e) {
    // We failed the translation lookup
    area = "data";
  }

  let message = t(`react_background_save_errors.messages.${type}`, {
    name: objectName,
    area: area,
    err: err,
  });
  if (message.indexOf("[missing") === 0) {
    // The lookup failed
    return t(`react_background_save_errors.unknown_errors`);
  } else {
    return message;
  }
};

const objectErrors = (dispatch, objects, nameKey, type) => {
  let errors = [];

  const suggestHelper = (obj, key) => {
    switch (`${type}.${key}`) {
      case "content.subject":
        return ceModalEditSubjectOpen(obj.client_content_id);
      case "content.name":
        return ceModalEditNameOpen(obj.client_content_id);
      default:
        return null;
    }
  };

  const wrapErrorWithHelper = (obj, key, errorText) => {
    const helperAction = suggestHelper(obj, key);

    if (!helperAction) return errorText;

    const dispatchHelper = clickWrap(() => dispatch(helperAction));

    return (
      <Fragment>
        {errorText}
        &nbsp;
        <a href="#" onClick={dispatchHelper}>
          {t(`react_background_save_errors.fix_it.${type}_${key}`)}
        </a>
      </Fragment>
    );
  };

  objects.forEach((obj) => {
    if (!obj.validation_errors) return;

    objectForEach(obj.validation_errors, (key, validationErrorsForField) => {
      validationErrorsForField.forEach((err) => {
        let errorText = formatError(dispatch, obj[nameKey], type, key, err);
        let errorWithHelper = wrapErrorWithHelper(obj, key, errorText);

        errors.push(errorWithHelper);
      });
    });
  });

  return errors;
};

export const ContentBackgroundSaveBanner = connect(mapStateToProps)((props) => {
  let errors = [
    ...objectErrors(props.dispatch, props.contents, "name", "content"),
    ...objectErrors(
      props.dispatch,
      props.attachments,
      "attachment_name",
      "attachment",
    ),
    ...objectErrors(props.dispatch, [props], "name", "campaign"), // Covers errors on the root campaign
  ];

  return (
    <div className="alert alert-error background-save-error-banner">
      <button
        className="close"
        type="button"
        onClick={() => props.dispatch(ceBackgroundSaveHideErrorBanner())}
      >
        ×
      </button>
      <p>{t("phrases.react_content.changes_not_saved_list")}:</p>
      <ul>
        {errors.map((error, ind) => {
          return <li key={ind}>{error}</li>;
        })}
      </ul>
    </div>
  );
});
